import { Link as RouterLink } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Box, Grid, Link, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import translate from "i18n/translate";
import { AUTH_ROOT_ROUTE, FORGOT_PASSWORD_ROUTE } from "routes/auth/authPaths";
import useLogin from "./useLogin";
import useStyles from "./loginStyles";
import { SrAlert, SrButton, SrInput, SrInputPassword } from "../../../common";
import { AUTH_TITLE_SPACE } from "../../../../constants";

const initialValues = {
  email: "",
  password: "",
};

const validationSchema = Yup.object().shape({
  email: Yup.string().required(translate("auth.emailRequired")),
  password: Yup.string().required(translate("auth.passwordRequired")),
});

const Login = () => {
  const classes = useStyles();
  const { error, login } = useLogin();

  return (
    <Grid container justifyContent="center">
      <Grid
        container
        item
        justifyContent="center"
        className={classes.container}
      >
        <Grid container item xs={12} justifyContent="center">
          <Box mb={AUTH_TITLE_SPACE}>
            <Typography variant="h2" align="center" id="login-heading">
              {translate("auth.login")}
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={login}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              touched,
              values,
              isSubmitting,
            }) => (
              <Form noValidate aria-labelledby="login-heading">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <SrInput
                      label={<FormattedMessage id="common.email" />}
                      required
                      fullWidth
                      error={Boolean(errors.email && touched.email)}
                      helperText={touched.email && errors.email}
                      id="email"
                      name="email"
                      autoComplete="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <SrInputPassword
                      label={translate("common.password")}
                      required
                      fullWidth
                      error={Boolean(errors.password && touched.password)}
                      helperText={touched.password && errors.password}
                      name="password"
                      id="password"
                      autoComplete="current-password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                    />
                  </Grid>
                  {error && (
                    <Grid item xs={12}>
                      <SrAlert severity="error">{error}</SrAlert>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <SrButton
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      {translate("auth.login")}
                    </SrButton>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
        <Grid item xs={12}>
          <Box mt={4}>
            <Link
              className={classes.forgotPassword}
              color="textPrimary"
              component={RouterLink}
              to={AUTH_ROOT_ROUTE + FORGOT_PASSWORD_ROUTE}
            >
              {translate(`auth.forgotMyPassword`)}
            </Link>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Login;
